(function () {
  'use strict';

  /* Arama terimini olduğu gibi (çift tırnak içinde tam öbek olarak) gönder */
  function fbTransform(raw) {
    var q = (raw || '').trim();
    if (!q) return raw;

    // Varsa eski title: veya yıldız gibi kalıntıları temizle
    q = q.replace(/title:/gi, '').replace(/[*"]/g, '').trim();
    if (!q) return raw;

    // Terimi çift tırnak içine alarak tam kelime eşleşmesi yaptır
    return '"' + q + '"';
  }

  function fbStripMarkers(v) {
    return (v || '').replace(/title:/gi, '').replace(/&quot;/g, '').replace(/["*]/g, '').trim();
  }

  /* Form gönderilirken */
  window.addEventListener('submit', function (e) {
    try {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/search') === -1) return;
      var input = form.querySelector('input[name="q"]');
      if (input && input.value) input.value = fbTransform(input.value);
    } catch (err) {}
  }, true);

  /* Enter tuşuna basıldığında */
  window.addEventListener('keydown', function (e) {
    try {
      if (e.key !== 'Enter') return;
      var el = e.target;
      if (!el || el.tagName !== 'INPUT') return;
      if (!el.closest || !el.closest('predictive-search-component')) return;
      if (el.value) el.value = fbTransform(el.value);
    } catch (err) {}
  }, true);

  /* Kutunun içinde kullanıcıya tırnakları gösterme */
  function fbCleanDisplay() {
    try {
      var inputs = document.querySelectorAll('input[name="q"]');
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].value) inputs[i].value = fbStripMarkers(inputs[i].value);
      }
      var terms = document.querySelectorAll('.fps-search-term');
      for (var j = 0; j < terms.length; j++) {
        if (terms[j].textContent) terms[j].textContent = fbStripMarkers(terms[j].textContent);
      }
    } catch (err) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fbCleanDisplay);
  } else {
    fbCleanDisplay();
  }
})();